var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-info-file"},[_c('div',{staticClass:"ws-info-file__upload-btns"},[_c('WsStateFileItem',{staticClass:"mb-2",attrs:{"url":_vm.value,"updatable":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }